export const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};

export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
    mode: width > height ? "Landscape" : "Portrait",
  };
}

export const handleLogin = async (url, jwtEncode) => {
  localStorage.clear();
  sessionStorage.clear();
  const payload = {
    origin: window.location.origin,
    redirectUri: window.location.pathname,
  };
  const token = jwtEncode(payload, "");
  window.location.href = `${url}?referrer=${token}`;
};
